import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

export default function DemoPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <div className="container-praise py-8 px-4 sm:px-6">
        {/* Header */}
        <div className="relative mb-12">
          <motion.button
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </motion.button>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="flex justify-center mt-8"
          >
            <img 
              src="https://llmdocs.s3.us-east-1.amazonaws.com/mygoodquotes/blogimages/mgqlogo2.png"
              alt="MyGoodQuotes Logo"
              className="h-16 sm:h-20 w-auto"
            />
          </motion.div>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="max-w-4xl mx-auto"
        >
          {/* Title and Description */}
          <div className="text-center mb-12">
            <h1 className="text-3xl sm:text-4xl font-display font-bold text-gray-900 mb-6">
              See MyGoodQuotes in Action
            </h1>
            <p className="text-lg sm:text-xl text-gray-600">
              Watch how easy it is to capture, organize, and share your favorite quotes
            </p>
          </div>

          {/* Video Container */}
          <div className="card p-4 sm:p-6 mb-12">
            <div className="relative pb-[56.25%] overflow-hidden rounded-lg shadow-lg">
              <video
                className="absolute inset-0 w-full h-full"
                controls
                poster="https://llmdocs.s3.us-east-1.amazonaws.com/mygoodquotes/blogimages/homepage1.png"
              >
                <source
                  src="https://llmdocs.s3.us-east-1.amazonaws.com/mygoodquotes/mygoodquotes_animateddemo_music_credit.mp4"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>

          {/* Key Features */}
          <div className="grid md:grid-cols-2 gap-6">
            <div className="card p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                What You'll See
              </h2>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start gap-2">
                  <span className="font-medium text-brand-600">1.</span>
                  <span>Easy quote entry with rich formatting options</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-medium text-brand-600">2.</span>
                  <span>Organize quotes with favorites and collections</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-medium text-brand-600">3.</span>
                  <span>Share quotes with beautiful styling options</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="font-medium text-brand-600">4.</span>
                  <span>Export and backup your quote collection</span>
                </li>
              </ul>
            </div>

            <div className="card p-6">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Ready to Start?
              </h2>
              <p className="text-gray-600 mb-6">
                Join our early access program and be one of the first to experience MyGoodQuotes.
                Get started with a collection of your own meaningful quotes today.
              </p>
              <button
                onClick={() => navigate('/early-access')}
                className="btn-primary w-full"
              >
                Get Early Access
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}